const STORAGE_KEY = 'user-info'

const User = {
  username: null,
  display: '游客',
  _id: null,
  permissions: [],
  token: null,
  roles: null,
  load() {
    const data = localStorage.getItem(STORAGE_KEY)
    if (data)
      Object.assign(this, JSON.parse(data))
    return this
  },
  save() {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(this))
    return this
  },
  logout() {
    this.permissions = []
    this.username = null
    this.display = null
    this.roles = null
    this.save()
  },
  is_logined() {
    return !!this.username
  },
  get_name() {
    return this.display || this.username
  },
}

export default User



// WEBPACK FOOTER //
// ./client/src/user.js